/**
 * @file: description
 * @author: dongjing
 * @Date: 2020-02-20 20:35:26
 * @LastEditors: dongjing
 * @LastEditTime: 2020-02-24 11:32:07
 */
import React from 'react';
import DefaultAvatar from '@src/assets/default_avatar.png';
import './SFCAvatar.less';

export interface ISFCAvatarProps {
  src?: string;
  className?: string;
  style?: React.CSSProperties;
  onClick?: () => void;
}
type Props = ISFCAvatarProps;

export function SFCAvatar(props: Readonly<Props>) {
  const { src, className = '', style, onClick } = props;
  return (
    <div
      className={`common-presenter k-common-avatar ${className}`}
      style={style}
      onClick={onClick}
    >
      <img src={src ? src : DefaultAvatar} alt="" />
    </div>
  );
}

export default SFCAvatar;
